import { useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface MoveDeviceDialogProps {
    deviceId: number;
    targetNodeName: string;
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

const MoveDeviceDialog = ({ deviceId, targetNodeName, open, onClose, onConfirm }: MoveDeviceDialogProps) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        if (loading) return;
        setError('');
        onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        setError('');
        try {
            await onConfirm();
        } catch {
            setError('Не удалось перенести устройство');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            onKeyDown={(e) => { if (e.key === 'Enter' && !loading) handleConfirm(); }}
        >
            <DialogTitle>Перенести устройство</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Вы уверены, что хотите перенести устройство «{deviceId}» в «{targetNodeName}»?
                </DialogContentText>
                {error && <DialogContentText color="error" sx={{ mt: 1 }}>{error}</DialogContentText>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>Отмена</Button>
                <Button onClick={handleConfirm} variant="contained" disabled={loading} disableElevation autoFocus>
                    {loading ? <CircularProgress size={18} /> : 'Перенести'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MoveDeviceDialog;
